import React, { useState } from "react";
import Container from "Components/Container/Container";
import Input from "form/Inputs/Input";
import useInput from "form/Hooks/user-input";
import Textarea from "form/Inputs/Textarea";
import ReCAPTCHA from "react-google-recaptcha";
import Spinner from "Components/RequestHandler/Spinner";
import line from "assests/contact/3.png";
import line_ar from "assests/contact/3-ar.png";
import { useTranslation } from "react-i18next";
const Form = () => {
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [formStatus, setFormStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { t, i18n } = useTranslation();

  // reCAPTCHA site key
  const RECAPTCHA_SITE_KEY = "6LfmMA8sAAAAALybXAMHfcJIf1pRCTkCUC9VuscP";

  const onCaptchaChange = (value) => {
    setCaptchaVerified(!!value); // If value exists, captcha is verified
    setCaptchaToken(value); // Store the captcha token
  };

  const {
    value: fullNameInput,
    isValid: fullNameIsValid,
    HasError: fullNameHasError,
    inputChangeHandler: fullNameChangeHandler,
    inputBlurHandler: fullNameBlurHanlder,
    reset: fullNameReset,
  } = useInput((value) => /^[a-zA-Z]+\s[a-zA-Z]+$/.test(value));

  const {
    value: emailInput,
    isValid: emailIsValid,
    HasError: emailHasError,
    inputChangeHandler: emailChangeHandler,
    inputBlurHandler: emailBlurHanlder,
    reset: emailReset,
  } = useInput((value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));

  const {
    value: companyInput,
    inputChangeHandler: companyChangeHandler,
    inputBlurHandler: companyBlurHanlder,
    reset: companyReset,
  } = useInput((value) => /^[a-zA-Z\s]*$/.test(value)); // Optional

  const {
    value: subjectInput,
    inputChangeHandler: subjectChangeHandler,
    inputBlurHandler: subjectBlurHanlder,
    reset: subjectReset,
  } = useInput((value) => /^[a-zA-Z\s]*$/.test(value)); // Optional

  const {
    value: messageInput,
    isValid: messageIsValid,
    HasError: messageHasError,
    inputChangeHandler: messageChangeHandler,
    inputBlurHandler: messageBlurHanlder,
    reset: messageReset,
  } = useInput((value) => value.trim().length !== 0);

  const clearInputs = () => {
    fullNameReset();
    emailReset();
    companyReset();
    subjectReset();
    messageReset();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (fullNameIsValid && emailIsValid && messageIsValid && captchaVerified) {
      const formData = {
        full_name: fullNameInput,
        email: emailInput,
        company: companyInput,
        subject: subjectInput,
        message: messageInput,
        recaptcha_token: captchaToken,
      };

      try {
        setIsLoading(true);
        const response = await fetch(
          "https://phplaravel-1177998-4901667.cloudwaysapps.com/api/en/contact_form",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        if (response.ok) {
          setFormStatus("success");
          clearInputs(); // Clear inputs on success
        } else {
          setFormStatus("failed");
        }
      } catch (error) {
        setFormStatus("failed");
      } finally {
        setIsLoading(false);
      }

      // Set a timeout to clear the form status after 5 seconds
      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    } else {
      setFormStatus("failed");
      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    }
  };
  return (
    <div className="bg-secondary py-primary relative">
      <div
        className={`absolute hidden xl:block top-0 ${
          i18n.language === "ar"
            ? "-left-[15.65rem] xxl:-left-[9.65rem]"
            : "-right-[15.65rem] xxl:-right-[9.65rem]"
        } `}
      >
        <img
          className=""
          src={i18n.language === "ar" ? line_ar : line}
          alt=""
        />
      </div>
      <Container>
        <h2 className="text-4xl text-primary titles-font">
          {t("conact_form")}
        </h2>
        <p
          className={`text-center mt-2  ${
            formStatus === "success" ? "text-green-500" : "text-red-500"
          }`}
        >
          {formStatus === "success"
            ? "Your message has been successfully sent."
            : formStatus === "failed"
            ? "There was an error sending your message. Please try again."
            : ""}
        </p>

        <form className="mt-10 lg:mt-20" onSubmit={handleSubmit}>
          <span className="flex flex-col lg:flex-row items-center gap-x-12">
            <Input
              type="text"
              label={`${t("full_name")} *`}
              id="register-full-name"
              value={fullNameInput}
              onChange={fullNameChangeHandler}
              onBlur={fullNameBlurHanlder}
              hasError={fullNameHasError}
              errorMessage=""
            />
            <Input
              type="email"
              label={`${t("email")} *`}
              id="register-email"
              value={emailInput}
              onChange={emailChangeHandler}
              onBlur={emailBlurHanlder}
              hasError={emailHasError}
              errorMessage=""
            />
          </span>
          <span className="flex flex-col lg:flex-row items-center gap-x-12 lg:my-8">
            <Input
              type="text"
              label={`${t("company")} *`}
              id="company"
              value={companyInput}
              onChange={companyChangeHandler}
              onBlur={companyBlurHanlder}
              hasError=""
              errorMessage=""
            />
            <Input
              type="text"
              label={`${t("subject")} *`}
              id="subject"
              value={subjectInput}
              onChange={subjectChangeHandler}
              onBlur={subjectBlurHanlder}
              hasError=""
              errorMessage=""
            />
          </span>

          <Textarea
            type="text"
            label={`${t("your_message")} *`}
            id="message"
            value={messageInput}
            onChange={messageChangeHandler}
            onBlur={messageBlurHanlder}
            hasError={messageHasError}
            errorMessage=""
          />

          <div className="mt-8">
            {/* Add reCAPTCHA component */}
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={onCaptchaChange}
            />
          </div>

          <button
            type="submit"
            className={`bg-primary uppercase text-white px-10 text-lg py-3  text-sm mt-10 mx-auto w-max flex items-center gap-x-2 justify-center ${
              !captchaVerified ? "opacity-50 cursor-not-allowed" : ""
            }`}
            // disabled={!captchaVerified}
          >
            {isLoading && <Spinner isWhite={true} />}
            {t("submit")}
          </button>
        </form>
      </Container>
    </div>
  );
};

export default Form;
